import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.jpg";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function Login({ saveUserData }) {
  let navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [messageError, setmessageError] = useState("");

  async function handleLogin(values) {
    try {
      setisLoading(true);

      // Send the request and await the response
      let { data } = await axios.post(
        `https://api.elza2.store/api/v1/auth/signin`,
        values
      );

      if (data.status === "success") {
        localStorage.setItem("Auth", `Bearer ${data.token}`);
        saveUserData();
        setisLoading(false);
        navigate("/");
      }
    } catch (err) {
      setisLoading(false);

      // Check if the error is related to the email being wrong
      const errorMessage = err.response?.data?.error;
      if (errorMessage === "email is wrong") {
        setmessageError("Email is incorrect. Redirecting to registration...");

        // Redirect to registration page after 2 seconds
        setTimeout(() => {
          navigate("/register");
        }, 2000);
      } else {
        // Set the error message for other types of errors
        setmessageError(errorMessage || "An error occurred. Please try again.");
      }
    }
  }

  // Validation schema using Yup
  let validationSchema = Yup.object({
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string()
      .required("Password is required"),
  });

  let formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: handleLogin,
  });

  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      <Link to="/">
        <button className="absolute z-10 top-4 left-4 bg-white text-black py-2 px-4 rounded-lg hover:bg-blue-600">
          <IoMdArrowRoundBack />
        </button>
      </Link>
      {/* Left half: Form */}
      <div className="bg-image w-full lg:w-1/2 flex items-center justify-center bg-gray-900 p-8">
        <div className="w-full bg-white max-w-md space-y-8 bg-gray-800 shadow rounded-lg p-8">
          <h2 className="text-center text-3xl font-bold text-gray">
            Welcome Back
          </h2>
          <p className="text-center text-gray-400">
            Login and get your awesome Stickers and more...
          </p>
          {messageError && (
            <div className="alert alert-danger bg-red-500 text-gray">
              {messageError}
            </div>
          )}
          <form className="mt-8 space-y-6" onSubmit={formik.handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email" className="sr-only">
                  Email address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Your Email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email && formik.touched.email ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                {formik.errors.password && formik.touched.password ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-sm">
                <Link
                  to='/register'
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Register for an account
                </Link>
              </div>

            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {isLoading ? (
                  <span className="loader"></span>
                ) : (
                  "Sign in to your account"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Right half: Image */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-gray-900">
        <div className="relative">
          <img src={logo} alt="Logo" className="max-w-full h-auto" />
        </div>
      </div>
    </div>
  );
}
